import React from 'react';
import { NavLink, useLocation } from 'react-router';
import { Home, UtensilsCrossed, ClipboardList, MapPin, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { cn } from '../../utils/cn';

const navItems = [
  { path: '/', icon: Home, label: 'Accueil' },
  { path: '/menu', icon: UtensilsCrossed, label: 'Menu' },
  { path: '/commandes', icon: ClipboardList, label: 'Commandes', requiresAuth: true },
  { path: '/localisation', icon: MapPin, label: 'Localisation' },
  { path: '/profil', icon: User, label: 'Profil' },
];

export const BottomNav: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Don't show nav on admin pages
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-bg-darker border-t border-gray-800 md:hidden" aria-label="Navigation mobile">
      <div className="flex items-center justify-around max-w-lg mx-auto h-20 pb-safe-bottom">
        {navItems.map(({ path, icon: Icon, label, requiresAuth }) => {
          // Skip items that require auth if not authenticated
          if (requiresAuth && !isAuthenticated) {
            return null;
          }

          const isActive = location.pathname === path ||
            (path !== '/' && location.pathname.startsWith(path));

          return (
            <NavLink
              key={path}
              to={path}
              className={cn(
                'flex flex-col items-center justify-center w-16 h-full',
                'transition-colors duration-200'
              )}
            >
              <Icon
                className={cn(
                  'w-5 h-5 mb-1 transition-colors duration-200',
                  isActive ? 'text-primary-orange' : 'text-text-muted'
                )}
              />
              <span
                className={cn(
                  'text-xs transition-colors duration-200',
                  isActive ? 'text-primary-orange font-medium' : 'text-text-muted'
                )}
              >
                {label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
